import { Box, Typography, useTheme } from "@mui/material";
import { motion } from "motion/react";
import styles from "./Example.module.css";

type ExampleProps = {
    text: string;
    value: string;
    onClick: (value: string) => void;
    delay: number;
};

let itemVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 0 }
};

export const Example = ({ text, value, onClick, delay }: ExampleProps) => {
    const theme = useTheme();

    return (
        <motion.li
            layoutId={value}
            variants={itemVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ delay: delay * 0.3, duration: delay === 0 ? 0.3 : 0.5 }}
            style={{ display: "flex", listStyle: "none", flexGrow: 1, flexBasis: "180px", justifyContent: "center" }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    color: theme.palette.text.primary,
                    borderRadius: "0.8rem",
                    border: `1px solid ${theme.palette.divider}`,
                    padding: "0.4rem",
                    minWidth: "180px",
                    minHeight: "60px",
                    textAlign: "center",
                    cursor: "pointer",
                    marginBottom: "0.5rem",
                    wordBreak: "break-word",
                    transformStyle: "preserve-3d",
                    userSelect: "none",
                    backgroundColor: theme.palette.cardBackground,
                    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                    transition: "transform 0.2s, box-shadow 0.2s, color 0.2s",
                    position: "relative",
                    overflow: "hidden",

                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: "100%",
                        height: "100%",
                        background: theme.palette.gridRowHover,
                        zIndex: -1,
                        borderRadius: "inherit",
                        transform: "translate(-50%, -50%) scale(0)",
                        transition: "transform 0.3s ease"
                    },

                    "&:hover::before": {
                        transform: "translate(-50%, -50%) scale(1)"
                    },
                    "&:hover": {
                        boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
                        transform: "translateY(-2px)"
                    }
                }}
                onClick={() => onClick(value)}
            >
                <Typography variant="body2" className={styles.exampleText} sx={{ position: "relative", zIndex: 1 }}>
                    {text}
                </Typography>
            </Box>
        </motion.li>
    );
};
